export default __webpack_public_path__ + "static/media/tiqassist_logo.f682ea59.svg";